import { render, staticRenderFns } from "./SearchLongRead.vue?vue&type=template&id=54854d38&scoped=true&"
import script from "./SearchLongRead.vue?vue&type=script&lang=js&"
export * from "./SearchLongRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54854d38",
  null
  
)

export default component.exports